<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h4>Receta: Detalles</h4>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">Duracion</th>
          <th scope="col">Indicacion</th>
          <th scope="col">Observación</th>
          <th scope="col">DosisNombre</th>
          <th scope="col">RecetaFechaReg</th>
          <th scope="col">FrecuenciaNombre</th>
          <th scope="col">ElementoCodigo</th>
          <th scope="col">ElementoNombre</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="recetadet in datosPaginados" :key="recetadet.idRecetaDet">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(recetadet.idRecetaDet)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(recetadet.idRecetaDet)" title="Editar">edit_square</i></td>
          <td>{{recetadet.duracion}}</td>
          <td>{{recetadet.indicacion}}</td>
          <td>{{recetadet.observacion}}</td>
          <td>{{recetadet.dosisNombre}}</td>
          <td>{{getFormattedDate(recetadet.recetaFechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{recetadet.frecuenciaNombre}}</td>
          <td>{{recetadet.elementoCodigo}}</td>
          <td>{{recetadet.elementoNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteRecetaDet(recetadet.idRecetaDet)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idRecetaDet" class="form-label">IdRecetaDet</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idRecetaDet" name="idRecetaDet" v-model="datoRecetaDet.idRecetaDet" disabled>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Receta -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idReceta" class="form-label"> Receta</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idReceta" name="idReceta" v-model="datoRecetaDet.idReceta">
                      <option v-for="receta in recetas" :value="receta.idReceta" :key="receta.idReceta">
                        {{ receta.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Receta -->
<!-- Botón Lista de Valores  Elemento -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idElemento" class="form-label"> Elemento</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idElemento" name="idElemento" v-model="datoRecetaDet.idElemento">
                      <option v-for="elemento in elementos" :value="elemento.idElemento" :key="elemento.idElemento">
                        {{ elemento.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Elemento -->
<!-- Botón Lista de Valores  Frecuencia -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idFrecuencia" class="form-label"> Frecuencia</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idFrecuencia" name="idFrecuencia" v-model="datoRecetaDet.idFrecuencia">
                      <option v-for="frecuencia in frecuencias" :value="frecuencia.idFrecuencia" :key="frecuencia.idFrecuencia">
                        {{ frecuencia.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Frecuencia -->
<!-- Botón Lista de Valores  Dosis -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idDosis" class="form-label"> Dosis</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idDosis" name="idDosis" v-model="datoRecetaDet.idDosis">
                      <option v-for="dosis in dosiss" :value="dosis.idDosis" :key="dosis.idDosis">
                        {{ dosis.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Dosis -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="duracion" class="form-label">Duracion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="duracion" name="duracion" v-model="datoRecetaDet.duracion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="indicacion" class="form-label">Indicacion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="indicacion" name="indicacion" v-model="datoRecetaDet.indicacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observación</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="observacion" name="observacion" v-model="datoRecetaDet.observacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarRecetaDet" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditRecetaDet" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js';

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
      recetadets : [],
      datoRecetaDet : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      recetas: [],
      elementos: [],
      frecuencias: [],
      dosiss: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.fetchRecetas()
    this.fetchElementos()
    this.fetchFrecuencias()
    this.fetchDosiss()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas(){
      return Math.ceil(this.recetadets.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwrecetadets/nombre/'+this.nombreBusqueda).then(response=>{
          this.recetadets=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.recetadets.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwrecetadets').then(response=>{
      this.recetadets=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.recetadets.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'idReceta'
        ,'idElemento'
        ,'idFrecuencia'
        ,'idDosis'
        ,'duracion'
        ,'indicacion'
        ,'observacion'
      ];
      const requiredFieldsText = [
        'idReceta'
        ,'idElemento'
        ,'idFrecuencia'
        ,'idDosis'
        ,'duracion'
        ,'indicacion'
        ,'observacion'
      ];
      return validarForm(this.datoRecetaDet, requiredFields, requiredFieldsText);
    },
    async guardarRecetaDet(){
      if(this.validarForm() === 1){
        try {
          await api.post('/recetadets', this.datoRecetaDet)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "RecetaDet creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditRecetaDet(){
      if(this.validarForm() === 1){
        try {
          await api.post('/recetadets', this.datoRecetaDet)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "RecetaDet creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoRecetaDet={}
      this.titulo   = 'Crear Receta: Detalles'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idRecetaDet){
      this.modalWindow = true
      if(idRecetaDet != null){    
           api.get('/vwrecetadets/'+idRecetaDet).then(resp=>{
          this.datoRecetaDet = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Receta: Detalles'
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idRecetaDet){
      if(idRecetaDet != null){
        this.$router.push('/recetadetmd/'+idRecetaDet)
      }
    },
    async deleteRecetaDet (idRecetaDet) {
      try{
        await api.delete('/recetadets/'+idRecetaDet)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
    fetchRecetas() {
      fetch('http://localhost:8080/api/v1/recetas')
        .then(response => response.json())
        .then(data => {
          this.recetas = data;
        })
        .catch(error => {
          console.error('Error fetching recetas:', error);
        });
    },
    fetchElementos() {
      fetch('http://localhost:8080/api/v1/elementos')
        .then(response => response.json())
        .then(data => {
          this.elementos = data;
        })
        .catch(error => {
          console.error('Error fetching elementos:', error);
        });
    },
    fetchFrecuencias() {
      fetch('http://localhost:8080/api/v1/frecuencias')
        .then(response => response.json())
        .then(data => {
          this.frecuencias = data;
        })
        .catch(error => {
          console.error('Error fetching frecuencias:', error);
        });
    },
    fetchDosiss() {
      fetch('http://localhost:8080/api/v1/dosiss')
        .then(response => response.json())
        .then(data => {
          this.dosiss = data;
        })
        .catch(error => {
          console.error('Error fetching dosiss:', error);
        });
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
